class News {
  constructor(element) {
    this.element = element;
    this.headline = element.dataset.headline;
    this.image = element.dataset.image;
    this.date = element.dataset.date;
    this.authorName = element.dataset.authorName;

    this.init();
  }

  init() {
    this.addToHead();
  }

  addToHead() {
    const structuredDataText = {
      "@context": "https://schema.org",
      "@type": "NewsArticle",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://google.com/article"
      },
      "headline": this.headline,
      "image": [this.image],
      "datePublished": this.date,
      "dateModified": this.date,
      "author": {
        "@type": "Person",
        "name": this.authorName
      },
      "publisher": {
        "@type": "Organization",
        "name": "Doijer&Kalff",
        "logo": {
          "@type": "ImageObject",
          "url": "https://doijerkalff.nl/logo.png"
        }
      }
    }
    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.textContent = JSON.stringify(structuredDataText);
    document.head.appendChild(script);
  }
}

export default News;
